import SessionCore from './session';

export default class LoopCheckCore {
	/**
	 * 无限重定向校验
	 * @param path 当前页面 path
	 * @param redirectCount 重定向次数
	 * @param duration 间隔时长，单位 s
	 */
	static check (path: string, redirectCount: number, duration: number): boolean {
		if (redirectCount < 1) redirectCount = 1;
		const urlStackInfo: Record<string, any>[] = SessionCore.getStackInfo(path);
		const length: number = urlStackInfo.length;
		// 首先校验 url 堆栈信息长度是否达到指定轮询次数
		if (length < redirectCount) return false;
		// 校验最新一条记录与倒数第 redirectCount 条记录时间差是否超过 duration
		const latestTimeStamp = urlStackInfo[length - 1].timeStamp;
		const tenThLatestTimeStamp = urlStackInfo[length - redirectCount].timeStamp;
		if (latestTimeStamp - tenThLatestTimeStamp > duration * 1000) return false;
		return true;
	}
}
